export default __webpack_public_path__ + "media/wind.061313a9.jpg";